/**
 * API 調用 Hook
 * 封裝 apiCall 邏輯，自動處理 token 和錯誤
 */

import { useCallback } from 'react';
import { apiCall } from '../services/apiService';

/**
 * 使用 API 調用的 Hook
 * @param {Function} getAccessToken - 獲取 token 的函數
 * @param {Object} tokenRef - token 的 ref 對象
 * @returns {Function} apiCall 函數
 */
export const useApi = (getAccessToken, tokenRef) => {
  const callApi = useCallback(async (url, options = {}) => {
    return await apiCall(url, options, getAccessToken, tokenRef);
  }, [getAccessToken, tokenRef]);

  return callApi;
};

